module.exports = __webpack_public_path__ + "d88ca195e3ff645c58170d35cb00fa89.png";